module.exports = __webpack_public_path__ + "static/ma-4-d64e6568efcc305e5274f1cfe421721f.png";